import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {EventAttendanceDeclarationApiModel} from '../models/event-attendance-declaration.api-model';

@Injectable({
  providedIn: 'root'
})
export class EventAttendanceDeclarationRestService {
  private readonly resource = '/event_attendance_declarations';

  constructor(private readonly http: HttpClient) {}

  public create(payload: {
    event: string;
    participantType?: 'PRIVATE' | 'BUSINESS';
    representedCompany?: string | null;
    projects?: string[];
  }): Observable<EventAttendanceDeclarationApiModel> {
    return this.http.post<EventAttendanceDeclarationApiModel>(`${environment.apiUrl}${this.resource}`, payload)
      .pipe(map((result) => plainToClass(EventAttendanceDeclarationApiModel, result)));
  }

  public update(declarationId: number, payload: {
    participantType?: 'PRIVATE' | 'BUSINESS';
    representedCompany?: string | null;
    projects?: string[];
  }): Observable<EventAttendanceDeclarationApiModel> {
    return this.http.post<EventAttendanceDeclarationApiModel>(`${environment.apiUrl}${this.resource}/${declarationId}/update`, payload)
      .pipe(map((result) => plainToClass(EventAttendanceDeclarationApiModel, result)));
  }

  public cancel(declarationId: number): Observable<EventAttendanceDeclarationApiModel> {
    return this.http.post<EventAttendanceDeclarationApiModel>(`${environment.apiUrl}${this.resource}/${declarationId}/cancel`, {})
      .pipe(map((result) => plainToClass(EventAttendanceDeclarationApiModel, result)));
  }
}

